const { utils } = require("./utils");

const filters = {
    root:{},
    init: (root) =>{
        filters.root = root;
    },
    getOpzioneUtente: (_label) =>{
        if (filters.root.utente != undefined && filters.root.utente.opzioni != undefined){
            for (var  i = 0 ; i < filters.root.utente.opzioni.length ; i++) {
                if (_label == filters.root.utente.opzioni[i].LABEL ){
                    return filters.root.utente.opzioni[i].VALORE;
                }
            }            
        }

        return null;
    },
    upperCase: (val) => {
        return val.toString().toUpperCase();
    },
    lowerCase: (val) => {
        return val.toString().toLowerCase();
    },
    ucfirst: (val) => {
        return val.toString().toUpperCase() + val.slice(1);
    },
    formattaImporto:(value) =>{
        if (value) {
            return global.utils.formatNumber(value);
        }
        else{
            return "0,00";
        }
    },
    formattaImportoInt:(value)=>{
        if (value) {
            return global.utils.formatNumberInt(value);
        }
        else{
            return "0";
        }
    },
    accorciaTesto : (value,length = 300, mostraPuntini = 1) =>{
        if (value) {
            if (value.toString().length > length){
                return value.toString().substring(0,length) + (mostraPuntini == 1 ? "..." : "");
            }
            else{
                return value.toString();
            }
        }
    },
    formatDate : (value) =>{
        if (value == '0000-00-00'){
            return "-";
        }
        if (value) {
            return global.moment(String(value),'YYYY-MM-DD').format('DD/MM/YYYY');
        }
    },
    formatDateOnly : (value) =>{
        if (!value) return null;
        return global.moment(String(value)).format('YYYY-MM-DD');
    },
    formatDateMonth : (value) =>{
        if (value) {
            return global.moment(String(value)).format('DD/MM');
        }
    },
    formatDateReverse : (value) =>{
        if (value) {
            return value.toString().substr(6,4) + "-" + value.toString().substr(3,2) + "-" + value.toString().substr(0,2);
        }
    },
    formatDateSmart : (value) =>{
        if (value) {
            return global.moment(String(value)).format('DD/MM/YY');
        }
    },
    formatDateTime : (value) =>{
        if (value == "-" || value == undefined || value == ""){
            return "-";
        }
        if (value) {
            return global.moment(String(value)).format('DD/MM/YYYY - HH:mm');
        }
    },
    formatDateTimeDp : (value) =>{
        if (value) {
            return global.moment(String(value)).format('DD/MM/YYYY HH:mm');
        }
    },
    formatDateTimeSeconds : (value) =>{
        if (value) {
            return global.moment(String(value)).format('DD/MM/YYYY - HH:mm:ss');
        }
    },
    formatDateTimeSecondsDatePicker : (value) =>{
        if (value) {
            return global.moment(String(value)).format('DD/MM/YYYY HH:mm:ss');
        }
    },
    formatTime: (value) => {
        if (value) {
            return moment(String('0000-01-01 '+ value)).format('HH:mm')
        }
    },
    formatTimeOnly: (value) => {
        if (value) {
            return moment(String(value)).format('HH:mm')
        }
    },
    formatTimeSecond: (value) => {
        if (value) {
            return moment(String(value)).format('HH:mm:ss')
        }
    },
    formatDateYear: (value) => {
        if (value) {
            return moment(String(value)).format('YYYY')
        }
    },
    formatMonth: (value) => {
        if (value) {
            var mese = global.utils.array.select(global.utils.arrayMesi,"ID_MESE",value,1)[0];
            return mese.DESCRIZIONE;
        }
    },
    formatDayWithDate: (value) => {
        if(value){
            const today = global.moment().startOf('day');
            const dataInput = global.moment(String(value)).startOf('day');
            if(dataInput.isSame(today, 'day')){
                return 'Oggi';
            }
            if(dataInput.isSame(today.subtract(1,'day'), 'day')){
                return 'Ieri'
            }
            const dayOfWeek = dataInput.format('dddd');
            const formattedDate = dataInput.format('DD/MM/YYYY');
            return `${formattedDate}`;
        }
        return '';
    },
    formatDayWithDateTime: (value) => {
        if (value) {
            // TO DO filters.getCurrentLangAlias()
            global.moment.locale('it');
            const today = global.moment().startOf('day');
            const inputDate = global.moment(String(value));
            const time = inputDate.format('HH:mm');
            if (inputDate.isSame(today, 'day')) {
                return `Oggi alle ${time}`;
            }
            if (inputDate.isSame(today.subtract(1, 'day'), 'day')) {
                return `Ieri alle ${time}`;
            }
            const dayOfWeek = inputDate.format('dddd');
            const formattedDate = inputDate.format('DD/MM/YYYY');
    
            return `${dayOfWeek} ${formattedDate} alle ${time}`;
        }
        return '';
    },
    addToDate : (value,quantita,tipo) => {
        var new_date = moment(value, "DD/MM/YYYY").add(quantita, tipo);
        return filters.formatDate(new_date);
    },
    removeFromDate : (value,quantita,tipo) => {
        var new_date = moment(value, "DD/MM/YYYY").remove(quantita, tipo);
        return filters.formatDate(new_date);
    },
    dateDiff : function(from,to){
        var diff = Math.abs(
            moment(from)
            .startOf('day')
            .diff(moment(to).startOf('day'), 'days')
        );
        return diff;        
    },
    selectAll : (idChk,_array) => {
        var selezionato = document.getElementById(idChk).checked == true ? 1 : 0;
        for (var i = 0 ; i < _array.length ; i++){
            _array[i].SELEZIONATO = selezionato;
        }
    },
    getGiornoSettimana :  (id,label) => {
        return global.utils.getGiornoSettimana(id)[label];
    },
    getMese : (id,label) =>{
        return global.utils.getMese(id)[label];
    },
    openPopUp : function(_id){
        console.trace();
        var myModal = new bootstrap.Modal(document.getElementById(_id), {
            //keyboard: false
        });
        myModal.show();
    },
    closePopUp : function(_id){
        //var myModal = new bootstrap.Modal(document.getElementById(_id));
        var myModalEl = document.getElementById(_id)
        var myModal =  bootstrap.Modal.getInstance(myModalEl);    
        myModal.hide();
    },
    toSelect2(_array,id,descrizione){
        return utils.array.toSelect2(_array,id,descrizione);
    },
    select2AddAll(model,array){
        model = new Array();
        for (var i = 0 ; i < array.length ; i++) {
            model.push(array[i].id);
        }
        return model;
    },
    generaArrayDate : function(){
        var arrayDate = new Array();
        var currentDate = moment(new Date()).format('YYYY-MM-DD');
        var max = 400;
        for (i = 0 ; i < max ; i++) {
            currentDate = moment(currentDate, "YYYY-MM-DD").add(1, "day").format('YYYY-MM-DD');
            arrayDate.push(currentDate);
        }
        return arrayDate;
    },

    arrayModuli(){
        return new Array(           
            {ID_MODULO:1,DESCRIZIONE: 'Activities'},
            {ID_MODULO:2,DESCRIZIONE: 'Hotel'},
            {ID_MODULO:3,DESCRIZIONE: 'Pacchetti'},
            {ID_MODULO:4,DESCRIZIONE: 'Voli'},
            {ID_MODULO:5,DESCRIZIONE: 'Camere'},
            {ID_MODULO:6,DESCRIZIONE: 'Generic'},
            {ID_MODULO:10,DESCRIZIONE: 'Ordini'},

            //DA 21 A 30 SI PARLA DI PERSONE FISICHE E GIURIDICHE (ADMIN, UTENTI, AGENZIE E FORNITORI)
            {ID_MODULO:21,DESCRIZIONE: 'Utenti Amministratori'},    // LIV 2
            {ID_MODULO:22,DESCRIZIONE: 'Utenti Clienti'},           // LIV 5
            {ID_MODULO:23,DESCRIZIONE: 'Opzioni Utenti'}, 
            {ID_MODULO:24,DESCRIZIONE: 'Aziende Agenzie'},          // LIV 3
            {ID_MODULO:25,DESCRIZIONE: 'Aziende Fornitori'},        // LIV 4

            //DA 31 IN POI SI PARLA DI AREE DEL PROGRAMMA (BLOG, CATEGORIE, NEWS, CONTENT, ECC...)
            {ID_MODULO:30,DESCRIZIONE: 'Manuali'},
            {ID_MODULO:31,DESCRIZIONE: 'Assicurazioni'},
            {ID_MODULO:32,DESCRIZIONE: 'Banners'},
            {ID_MODULO:33,DESCRIZIONE: 'Blogs'},
            {ID_MODULO:34,DESCRIZIONE: 'Categorie'},
            {ID_MODULO:35,DESCRIZIONE: 'Content'},
            {ID_MODULO:36,DESCRIZIONE: 'Coupons'},
            {ID_MODULO:37,DESCRIZIONE: 'Destinazioni'},
            {ID_MODULO:38,DESCRIZIONE: 'Faqs'},
            {ID_MODULO:39,DESCRIZIONE: 'Guest Book'},
            {ID_MODULO:40,DESCRIZIONE: 'Home Page'},
            {ID_MODULO:41,DESCRIZIONE: 'Liste'},
            {ID_MODULO:42,DESCRIZIONE: 'Locandine'},
            {ID_MODULO:43,DESCRIZIONE: 'Messaggi'},
            {ID_MODULO:44,DESCRIZIONE: 'News'},
            {ID_MODULO:45,DESCRIZIONE: 'Newsletters'},
            {ID_MODULO:46,DESCRIZIONE: 'Routers'},
            {ID_MODULO:47,DESCRIZIONE: 'Shops'},
            {ID_MODULO:48,DESCRIZIONE: 'Tessere'},

            //DA 50 IN POI DESTINAZIONI
            {ID_MODULO:51,DESCRIZIONE: 'Stati'},
            {ID_MODULO:52,DESCRIZIONE: 'Regioni'},
            {ID_MODULO:53,DESCRIZIONE: 'Province'},
            {ID_MODULO:54,DESCRIZIONE: 'Comuni'},
            {ID_MODULO:55,DESCRIZIONE: 'Aree'},

        );
    },

    moduleRoute(modulo){
        switch (modulo){
            case 1:     return 'Activities';
            case 2:     return 'Hotels';
            case 3:     return 'Packages';
            case 4:     return 'Flight';
            case 5:     return 'Camere';
            case 6:     return 'Generic';
            case 10:    return 'Ordini';

            //DA 21 A 30 SI PARLA DI PERSONE FISICHE E GIURIDICHE (ADMIN, UTENTI, AGENZIE E FORNITORI)
            case 21:    return 'UtentiCms';             // LIV 2
            case 22:    return 'UtentiClienti';         // LIV 5
            case 23:    return 'Opzioni Utenti'; 
            case 24:    return 'Agenzie';               // LIV 3
            case 25:    return 'Fornitori';             // LIV 4

            //DA 31 IN POI SI PARLA DI AREE DEL PROGRAMMA (BLOG, CATEGORIE, NEWS, CONTENT, ECC...)
            case 30:    return 'Manuali';
            case 31:    return 'Assicurazioni';
            case 32:    return 'Banners';
            case 33:    return 'Blogs';
            case 34:    return 'Categorie';
            case 35:    return 'Content';
            case 36:    return 'Coupons';
            case 37:    return 'Destinazioni';
            case 38:    return 'Faqs';
            case 39:    return 'Guest Book';
            case 40:    return 'Home Page';
            case 41:    return 'Liste';
            case 42:    return 'Locandine';
            case 43:    return 'Messaggi';
            case 44:    return 'News';
            case 45:    return 'Newsletters';
            case 46:    return 'Routers';
            case 47:    return 'Shops';
            case 48:    return 'Tessere';
            case 49:    return 'Varianti';

            default:    return 'Start';
        }
    },

    moduleName(modulo){
        switch (modulo){
            case 1:     return 'Attivita`';
            case 2:     return 'Hotel';
            case 3:     return 'Pacchetti';
            case 4:     return 'Voli';
            case 5:     return 'Camere';
            case 6:     return 'Generic';
            case 10:    return 'Ordini';

            //DA 21 A 30 SI PARLA DI PERSONE FISICHE E GIURIDICHE (ADMIN, UTENTI, AGENZIE E FORNITORI)
            case 21:    return 'Utenti Amministratori'; // LIV 2
            case 22:    return 'Utenti Clienti';        // LIV 5
            case 23:    return 'Opzioni Utenti'; 
            case 24:    return 'Aziende Agenzie';       // LIV 3
            case 25:    return 'Aziende Fornitori';     // LIV 4

            //DA 31 IN POI SI PARLA DI AREE DEL PROGRAMMA (BLOG, CATEGORIE, NEWS, CONTENT, ECC...)
            case 30:    return 'Manuali';
            case 31:    return 'Assicurazioni';
            case 32:    return 'Banners';
            case 33:    return 'Blogs';
            case 34:    return 'Categorie';
            case 35:    return 'Content';
            case 36:    return 'Coupons';
            case 37:    return 'Destinazioni';
            case 38:    return 'Faqs';
            case 39:    return 'Guest Book';
            case 40:    return 'Home Page';
            case 41:    return 'Liste';
            case 42:    return 'Locandine';
            case 43:    return 'Messaggi';
            case 44:    return 'News';
            case 45:    return 'Newsletters';
            case 46:    return 'Routers';
            case 47:    return 'Shops';
            case 48:    return 'Tessere';
            case 49:    return 'Varianti';

            default:    return 'Start';
        }
    },

    getModuloCorrente(path){
        if(path.startsWith('/')){
            path = path.slice(1)
        }
        const mod = filters.root.arrayTipoModuli?.find(modulo => modulo.CUSTOM_1 === path);
        return mod;
    },

    getTipologiaNotifica(path){
        var idModulo = this.getModuloCorrente(path)['ID_TIPOLOGICA'];
        var arr = utils.array.select(filters.root.arrayTipologieNotifiche,"FK_ID_MODULO",idModulo,1)[0];
        console.log(arr);
        if (arr != undefined){
            return arr['FK_TIPOLOGIA_NOTIFICA'];
        }
        return "-";
    },

    iconaProdotto(modulo){
        switch (modulo){
            case 1:     return 'fa-bullhorn';
            case 2:     return 'fa-hotel';
            case 3:     return 'fa-suitcase';
            case 4:     return 'fa-plane';
            case 5:     return 'fal fa-bed-alt';
            default:    return 'fal fa-box';
        }
    },
    
    getLabel(_array,_chiave,_valore,_descrizione){
        var item = utils.array.select(_array,_chiave,_valore,1)[0];
        if (item != undefined){
            return item[_descrizione];
        }
        return "";
    },
    getLabelOpzione(idOpzioneTipologica,label='DESCRIZIONE'){
        console.log(filters.root?.arrayAllOpzioni);
        var arr = utils.array.select(filters.root?.arrayAllOpzioni,"ID_OPZIONE_TIPOLOGICA",idOpzioneTipologica,1)[0];
        if (arr != undefined){
            return arr[label];
        }
        return "-";
    },
    getModuloById(id){
        var arr = utils.array.select(filters.root.arrayAllOpzioni,"ICONA",id,1)[0];
        if (arr != undefined){
            return arr['CUSTOM_1'];
        }
        return "-";
    },
    getIdOpzioneLabel(label){
        const id = filters.root?.utente?.opzioni?.find(opzione => opzione.LABEL === label);
        return id;
    },
    getCustomOpzione(label='DESCRIZIONE'){
        var idOpzioneTipologica = this.getIdOpzioneLabel(label);
        if(idOpzioneTipologica != undefined){
            idOpzioneTipologica = idOpzioneTipologica['VALORE']
        }
        if(filters.root.arrayAllOpzioni != undefined){
             var arr = utils.array.select(filters.root.arrayAllOpzioni,"ID_OPZIONE_TIPOLOGICA",idOpzioneTipologica,1)[0];
        }
    
        if (arr != undefined){
            return arr['CUSTOM_1'];
        }
        return "-";
    },
    getOpzioniTipologiche(idTipologica,flgAttivo = 1){
        var arr = utils.array.select(filters.root.arrayAllOpzioni,"FK_ID_TIPOLOGICA",idTipologica);
        if (flgAttivo == 1){
            arr = utils.array.select(arr,"FLG_ATTIVO",1);
        }
        return arr;
    },

    getPnr(ordine){
        if (ordine.ID_ORDINE > 0 && ordine.hasOwnProperty("ANNO_ORDINE")){
            var str = "";
            var anno = ordine.ANNO_ORDINE.toString().substring(2);
            str = anno + "/";
            for (var i = 0 ; i < (5-ordine.PNR.toString().length) ;i++){
                str += "0";
            }
            str += ordine.PNR;
            return str;
        }
        return "";
    },

    getStatiOrdine(){
       return filters.root.arrayPraticaStato;
    },

    getCurrentLangDesc(){
        console.log("getCurrentLangDesc");
        if (filters == undefined || filters.root == undefined || filters.root.arrayLingue == undefined){
            return "";
        }
        for (var i = 0 ; i < filters.root.arrayLingue.length ; i++){
            if (filters.root.arrayLingue[i]['ID_GEO_STATO'] == filters.root.currentLang){
                return filters.root.arrayLingue[i]['NOME'];
            }
        }
        return "";
    },

    getCurrentLangAlias(){
        if (filters == undefined || filters.root == undefined || filters.root.arrayLingue == undefined){
            return "";
        }
        for (var i = 0 ; i < filters.root.arrayLingue.length ; i++){
            if (filters.root.arrayLingue[i]['ID_GEO_STATO'] == filters.root.currentLang){
                return filters.root.arrayLingue[i]['ICONA'];
            }
        }
        return "";
    },

    getLblStatoOrdine(id){
        var arr = utils.array.select(filters.getStatiOrdine(),"ID_OPZIONE_TIPOLOGICA",id,1);
        if (arr.length > 0){
            return arr[0]['DESCRIZIONE'];
        }
        return "";
    },

    getAnniOrdine(){
        var arr = new  Array(            
            {ID:2018,DESCRIZIONE:"2018"},
            {ID:2019,DESCRIZIONE:"2019"},
            {ID:2020,DESCRIZIONE:"2020"},
            {ID:2021,DESCRIZIONE:"2021"},
            {ID:2022,DESCRIZIONE:"2022"},
            {ID:2023,DESCRIZIONE:"2023"},
            {ID:2024,DESCRIZIONE:"2024"},
            {ID:2025,DESCRIZIONE:"2025"},
            {ID:2026,DESCRIZIONE:"2026"},
            {ID:2027,DESCRIZIONE:"2027"},
            {ID:2028,DESCRIZIONE:"2028"},
            {ID:2029,DESCRIZIONE:"2029"},
            {ID:2030,DESCRIZIONE:"2030"},
        );
        return arr;
    },

    getStato(id){
        var n = utils.array.select(filters.root.arrayGeoStati,"ID_STATO",id,1)[0];
        if (n != undefined){
            return n;
        }
        return {NOME:''};
    },

    getImgPathProdotto(url){
        return filters.root.GLOBAL_IMAGES_PATH + url;
    },

    //lasciare
    getImgPathProdottoOld(root,idProdotto,idStagione){
        return root.GLOBAL_IMAGES_PATH+'PRODOTTI/'+idProdotto+'/'+idStagione+'/'+idProdotto+'.jpg'
    },
    
    getImgPath(folder,id){
        //let fileName = filters.root.GLOBAL_IMAGES_PATH + folder +'/'+id+'.jpg';
        return filters.root.GLOBAL_IMAGES_PATH + folder +'/'+id;
        //return filters.root.GLOBAL_IMAGES_PATH +'/NOPHOTO/placeholder.jpg';        
    },
    
    getImgExist(folder,id){
        var fileName = filters.root.GLOBAL_IMAGES_PATH + folder +'/' + id;
        var dir = filters.root.GLOBAL_IMAGES_PATH;
        utils.ajax('travel/images',{ROOT:this.dir,URL:this.fileName}, (response) => {
            this.Image = response.data;
        });

        //
        /*
        if(fileName != undefined){
            return filters.root.GLOBAL_IMAGES_PATH + folder +'/' + id;
        } else { 
            return filters.root.GLOBAL_IMAGES_PATH +'/NOPHOTO/placeholder.jpg'; 
        }
        //return filters.root.GLOBAL_IMAGES_PATH + folder +'/'+id;
        */
               
    },

    getIconsExt: (extension) => {
        let icon = '';
            let iconColor = '';
            let backgroundColor = '';
            switch(extension.toLowerCase()){
            case 'pdf':
                icon = 'fal fa-file-pdf';
                iconColor = 'text-danger';
                backgroundColor = 'rgba(220, 53, 69, 0.2)'; // rosso, trasparente
                break;
            case 'doc':
            case 'docx':
                icon = 'fal fa-file-text';
                iconColor = 'text-primary';
                backgroundColor = 'rgba(0, 123, 255, 0.2)';
                break;
            case 'xls':
            case 'xlsx':
                icon = 'fal fa-file-excel';
                iconColor = 'text-success';
                backgroundColor = 'rgba(40, 167, 69, 0.2)';
                break;
            case 'jpg':
            case 'jpeg':
            case 'png':
            case 'gif':
                icon = 'fal fa-file-image';
                iconColor = 'text-info';
                backgroundColor = 'rgba(23, 162, 184, 0.2)';
                break;
            case 'zip':
            case 'rar':
                icon = 'fa fa-file-archive';
                iconColor = 'text-warning';
                backgroundColor = 'rgba(255, 193, 7, 0.2)';
                break;
            default:
                icon = 'fal fa-file';
                iconColor = 'text-secondary';
                backgroundColor = 'rgba(108, 117, 125, 0.2)';
            }
            return { icon, iconColor, backgroundColor };
    },
    splitCamelCaseAndSpaces(str) {
        return str.split(/(?=[A-Z])|\s+/).filter(word => word);
    },

    getInitials(fromStr) {
        let name = fromStr;
        const index = fromStr.indexOf("<");
        if (index !== -1) {
            name = fromStr.substring(0, index).trim();
        }
        let words = name.match(/[A-Z][a-z]*|[a-z]+|[0-9]+/g) || [];
        if(name.includes(' ')){
            words = name.split(/\s+/);
        }
        let initials =  words.map(word => word[0]).slice(0,3).join("").toUpperCase();
        return initials.replace(/^["']/, '');
    },

    getColorForEmail(fromStr) {
        let name = fromStr;
        const index = fromStr.indexOf("<");
        if (index !== -1) {
            name = fromStr.substring(0, index).trim();
        }
        let hash = 0;
        for (let i = 0; i < name.length; i++) {
            hash = name.charCodeAt(i) + ((hash << 5) - hash);
        }
        const colors = ["bg-primary", "bg-success", "bg-warning", "bg-info", "bg-secondary"];
        return colors[Math.abs(hash) % colors.length];
    },

    openRoute: function(route){
        global.router.push(route);
    },

    popover : function(){
        setTimeout(() => {
            var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
            var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
                return new bootstrap.Popover(popoverTriggerEl)
            });
        }, 500);   
    },

    wait : function(time,_handler){
        setTimeout(() => {
           _handler() ;
        }, time);   
    },

    hasFunzionalita : function(idFunzionalita){
        if (filters.root != undefined && filters.root.utente != undefined && filters.root.utente.funzionalita != undefined){
            for (var i = 0 ; i < filters.root.utente.funzionalita.length ; i++) {
                if (filters.root.utente.funzionalita[i].FK_ID_FUNZIONALITA == idFunzionalita){
                    return true;
                }
            }
        }
        return false;
    },

    draggableChangeHandler : function(event,_array,_search,chiave){
        var newIndex = event.newIndex;
        var oldIndex = event.oldIndex;
        var arr = utils.inGrid(_array,_search).arr;
        var item = utils.clone(arr[oldIndex]);				
        var itemSostituito = utils.clone(arr[newIndex]);
        //console.log(item,itemSostituito);				
        //STEP 1: ELIMINO L'ELEMENTRO TRASCINATO
        for (var i = 0 ; i < _array.length; i++){
            if (_array[i][chiave] == item[chiave]){
                _array.splice(i,1);
                break;
            }
        }
        //STEP 2: RIAGGIUNGO L'ELEMENTO TRASCINATO ALLA NUOVA POSIZIONE
        for (var i = 0 ; i < _array.length; i++){
            if (_array[i][chiave] == itemSostituito[chiave]){
                var nuovoIndice = newIndex > oldIndex ? (i+1) : (i);
                _array.splice(nuovoIndice,0,item);
                break;
            }
        }
        for (var i = 0 ; i < _array.length; i++){
            _array[i].ORDINE = (i+1);
        }
        return _array;
    },
    
    limitcounter : function(){
        let inputTextArea = document.getElementById("input-textarea");
        let characCount = document.getElementById("charac-count");
        let wordCount = document.getElementById("word-count");

        inputTextArea.addEventListener("input", () => {
        characCount.textContent = inputTextArea.value.length;
        let txt = inputTextArea.value.trim();
        wordCount.textContent = txt.split(/\s+/).filter((item) => item).length;
        });
    },
    resizeGrid : function(collapse,tableFixHead,boxCard){
        utils.wait(()=>{
            if (document.getElementById(collapse).classList.contains("show") ){
                //devo ridurre					
                document.getElementById(tableFixHead).style['min-height'] = "30rem";
                document.getElementById(tableFixHead).style['max-height'] = "30rem";
                
                document.getElementById(boxCard).style['min-height'] = "34.5rem";
                document.getElementById(boxCard).style['max-height'] = "34.5rem";
                
            }
            else{
                //devo ingrandire					
                document.getElementById(tableFixHead).style['min-height'] = "33.3rem";
                document.getElementById(tableFixHead).style['max-height'] = "33.3rem";
            
                document.getElementById(boxCard).style['min-height'] = "37.5rem";
                document.getElementById(boxCard).style['max-height'] = "37.5rem";
                
            }				
        },350);        
    },
    getQuoteOrdinate(ordine){
        var arrayProdotti = new Array();
        for (var i = 0 ; i < ordine.quote.length ; i++){
            var trovato = 0;
            //hotel
            if (ordine.quote[i].FK_ID_MODULO == 2){
                for (var j = 0 ; j < arrayProdotti.length ; j++){
                    if (ordine.quote[i].prodottoPadre.ID_PRODOTTO == arrayProdotti[j].ID_PRODOTTO ){
                        trovato = 1;
                        break;
                    }
                } 
                if (trovato == 0){
                    arrayProdotti.push({ID_PRODOTTO:ordine.quote[i].prodottoPadre.ID_PRODOTTO,FK_ID_MODULO:2,prodotto:ordine.quote[i].prodottoPadre})
                }
            }
            //ESCLUDO LE QUOTE GENERICHE
            else if (ordine.quote[i].FK_ID_MODULO != 6) {
                for (var j = 0 ; j < arrayProdotti.length ; j++){
                    if (ordine.quote[i].FK_ID_PRODOTTO == arrayProdotti[j].ID_PRODOTTO ){
                        trovato = 1;
                        break;
                    }
                }
                if (trovato == 0){
                    arrayProdotti.push({ID_PRODOTTO:ordine.quote[i].FK_ID_PRODOTTO,FK_ID_MODULO:ordine.quote[i].FK_ID_MODULO,prodotto:ordine.quote[i].prodotto})
                }
            }
        }
        //UNA VOLTA OTTENUTA UNA DISTINCT DEI PRODOTTI, RAGGRUPPO LE QUOTE PER PRODOTTO (O PRODOTTO PADRE NEL CASO DI HOTEL)
        for (var j = 0 ; j < arrayProdotti.length ; j++){
            arrayProdotti[j].quote = new Array();
            for (var i = 0 ; i < ordine.quote.length ; i++){
                if (ordine.quote[i].FK_ID_MODULO == 2){
                    if (ordine.quote[i].prodottoPadre.ID_PRODOTTO == arrayProdotti[j].ID_PRODOTTO ){
                        arrayProdotti[j].quote.push(ordine.quote[i]);
                    }
                }
                else if (ordine.quote[i].FK_ID_MODULO != 6){
                    if (ordine.quote[i].FK_ID_PRODOTTO == arrayProdotti[j].ID_PRODOTTO ){
                        arrayProdotti[j].quote.push(ordine.quote[i]);
                    }
                }
            }
        }
        //INFINE AGGIUNGO LE GENERICHE
        for (var i = 0 ; i < ordine.quote.length ; i++){
            if (ordine.quote[i].FK_ID_MODULO == 6){
                var item = {FK_ID_MODULO:6,quote:new Array(ordine.quote[i]),ID_PRODOTTO:0};
                arrayProdotti.push(item);
            }
        }
        console.log(arrayProdotti);
        return arrayProdotti;
    },

    formatBytes(bytes) {
        if (bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
    },
    translatePermissions(permString) {
        if (!permString || typeof permString !== 'string') return 'Permessi non disponibili';
    
        const type = permString[0] === 'd' ? 'Cartella' : 'File';
        const perms = permString.slice(1);
    
        const roles = ['proprietario', 'gruppo', 'altri'];
        const descrizioni = [];
    
        for (let i = 0; i < 3; i++) {
            const p = perms.slice(i * 3, i * 3 + 3);
            const parti = [];
    
            if (p[0] === 'r') parti.push('lettura');
            if (p[1] === 'w') parti.push('scrittura');
            if (p[2] === 'x') parti.push('esecuzione');
    
            if (parti.length > 0) {
                descrizioni.push(`${roles[i]}: ${parti.join(', ')}`);
            } else {
                descrizioni.push(`${roles[i]}: nessun accesso`);
            }
        }
    
        return `${type} (${descrizioni.join(' | ')})`;
    },
    
    accorciaNomeFile: (nomeFile, maxLength = 30) => {
        if (!nomeFile) return '';
        if (nomeFile.length <= maxLength) return nomeFile;
    
        const parts = nomeFile.split('.');
        const ext = parts.length > 1 ? '.' + parts.pop() : '';
        const restante = parts.join('.');
    
        const finale = restante.slice(-12);
        const accorciato = restante.slice(0, maxLength - finale.length - ext.length - 3);
    
        return accorciato + '...' + finale + ext;
    }, 

    getFileFromPath(path){
        if(!path) return path;
        const parts = path.split('/');
        if(parts[parts.length -1] != "" || parts[parts.length -1] != undefined || parts[parts.length -1] != " "){
            const cartella = parts[parts.length - 1];
             return cartella;
        }
    }

     
};

exports.filters = filters;



